<template>
  <v-app-bar class="header-nav-bar" fixed app :color="instance.theme.header_bgcolor" elevation="0">
    <header-cluvi-pay
      v-if="template.header_type === 'cluvi-pay'"
      :template="template"
    />

    <v-app-bar-nav-icon
      :color="instance.theme.header_txt_color"
      v-if="template.header_type === 'main' && supplier.count_services > 1"
      @click="SwitchLeftPanel()"
    />

    <v-btn
      icon
      v-if="template.header_type === 'main' && supplier.count_services === 1"
      @click="BackToMain()"
    >
      <v-icon :color="instance.theme.header_txt_color">fa-light fa-chevron-left</v-icon>
    </v-btn>
    <v-btn icon v-if="template.header_type === 'my_order'">
      <v-icon :color="instance.theme.header_txt_color">fa-light fa-chevron-left</v-icon>
    </v-btn>
    <v-btn icon v-if="template.header_type === 'internal'" @click="beforeGoBack()">
      <v-icon :color="instance.theme.header_txt_color">fa-light fa-chevron-left</v-icon>
    </v-btn>
    <v-btn icon v-if="template.header_type === 'to_main'" @click="BackToMain()">
      <v-icon :color="instance.theme.header_txt_color">fa-light fa-chevron-left</v-icon>
    </v-btn>
    <v-btn
      icon
      href="https://archies.cluvi.co/"
      link
      v-if="template.header_type === 'to_othersite'"
    >
      <v-icon :color="instance.theme.header_txt_color">fa-light fa-chevron-left</v-icon>
    </v-btn>
    <v-btn
      icon
      v-if="template.header_type === 'toOrderinprogress'"
      @click="toOrderinprogress()"
    >
      <v-icon :color="instance.theme.header_txt_color">fa-light fa-chevron-left</v-icon>
    </v-btn>
    <v-btn icon v-if="template.header_type === 'tomenu'" @click="ToMenu()">
      <v-icon :color="instance.theme.header_txt_color">fa-light fa-chevron-left</v-icon>
    </v-btn>
    <v-btn icon v-if="template.header_type === 'tohome'" @click="ToHome()">
      <v-icon :color="instance.theme.header_txt_color">fa-light fa-chevron-left</v-icon>
    </v-btn>
    <v-btn icon v-if="template.header_type === 'tobook'" @click="ToBook()">
      <v-icon :color="instance.theme.header_txt_color">fa-light fa-chevron-left</v-icon>
    </v-btn>
    <v-btn icon v-if="template.header_type === 'ordermyontable'" @click="NavigatorMyOrder()">
      <v-icon :color="instance.theme.header_txt_color">fa-light fa-chevron-left</v-icon>
    </v-btn>
    <v-btn
      icon
      v-if="template.header_type === 'back_action' && !openMenuTop"
      @click="ExecLambda()"
    >
      <v-icon :color="instance.theme.header_txt_color">fa-light fa-chevron-left</v-icon>
    </v-btn>
    <v-btn
      icon
      v-if="template.header_type === 'maincategories'"
      @click="MenuMainCategories()"
    >
      <v-icon :color="instance.theme.header_txt_color">fa-light fa-chevron-left</v-icon>
    </v-btn>

    <v-toolbar-title
      v-if="instance.id && (!template.label || template.label.length === 0) && template.header_type !== 'cluvi-pay'"
      class="toolbar-title-header-logo" :style="{ color: instance.theme.header_txt_color }"
    >
      <img v-if="template.header_type !== 'cluvi-pay'" :src="instance.header.logo" @click="GoSelectSupplier()" style="height: 100%;"/>
    </v-toolbar-title>

    <v-toolbar-title
      v-if="instance.id && template.label && template.label.length > 0 "
      class="ma-0 pa-0" :style="{ color: instance.theme.header_txt_color }"
    >
      <span v-html="template.label" />
    </v-toolbar-title>

    <v-spacer v-if="template.header_type === 'maincategories'" />

    <header-cart v-if="displayIconCartRight"></header-cart>
  </v-app-bar>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import { misMixins } from "@/mixins.js";
import HeaderCart from "./HeaderCart";
const HeaderCluviPay = () => import(/* webpackChunkName: "HeaderCluviPay" */ "./HeaderCluviPay.vue");


export default {
  name: "LayoutHeaderNavBar",
  components: {HeaderCart,HeaderCluviPay},
  mixins: [misMixins],
  data() {
    return {
      displayIconCartRight: false,
    }
  },
  computed: {
    ...mapState('customer', [ "supplier","instance" ]),
    ...mapState('order', ["service", "service_label","subservice","countProductsList", "otPurchaseId"]),
    ...mapState('ontable', ["productInCook", "navMyOrder"]),
    ...mapState('shared', ["openMenuTop", "backRoute"]),
    ...mapState('template', ["template"])
  },
  methods: {
    ...mapMutations('template', ["SwitchLeftPanel","TemplateActiveHeader"]),
    ...mapMutations('shared', ["setOpenMenuTop"]),
    ...mapMutations('ontable', ["SetNavigatorMyOrder" ]),
    ...mapMutations('bookings', ["SetBookBanner"]),
    NavigatorMyOrder() {
      if(this.navMyOrder === 0){
        this.$router.go(-1);
      } else if(this.navMyOrder === 1) {
        if (this.productInCook && this.countProductsList > 0 && this.otPurchaseId !== null) this.$router.go(-1);
        else this.SetNavigatorMyOrder(0);
      } else if(this.navMyOrder === 2) {
        if(location.pathname.includes('/cluvipay/')) {
          this.$router.push({
            name: "OnTableMenuDigital",
            params: { supplier_id: this.supplier.slug}
          });
        }else{
          this.$router.go(-1);
        };
        this.SetNavigatorMyOrder(0);
      };
    },
    toOrderinprogress() {
      this.$router.push({
        name: "DeliveryCartInProgress",
        params: { supplier_id: this.supplier.slug }
      });
    },
    ToBook() {
      this.$router.push({
        name: "Book",
        params: { supplier_id: this.supplier.slug }
      });
      this.SetBookBanner(false);
    },
    MenuMainCategories() {
      this.setOpenMenuTop(true);
      this.$router.push({
        name: "MainCategories",
        params: { supplier_id: this.supplier.slug }
      });
    },
    GoSelectSupplier() {
      this.$router.push({ name: "Main" });
    },
    ToHome() {
      if (this.service === "on_table") {
        this.$router.push({
          name: "OnTableHome",
          params: { supplier_id: this.supplier.slug }
        });
      }else {
        this.$router.push({
          name: "Home",
          params: { supplier_id: this.supplier.slug }
        }).catch(() => {});
      }
    },
    ToMenu() {
      this.$router.push({
        name: "Menu",
        params: { supplier_id: this.supplier.slug }
      });
    },
    ExecLambda() {
      this.setOpenMenuTop(!this.openMenuTop);
    },
    BackToMain() {
      this.$router.push({
        name: "Main"
      });
    },
    beforeGoBack() {
      if(this.$route.name === 'Branch' && this.backRoute === '/') this.BackToMain();
      else this.back();
    }
  },
  watch:{
    '$route' (to){
      if(to.name === 'Menu' ||
          to.name === 'MainCategories' ||
          to.name === 'OnTableHome' ||
          to.name === 'Home' ||
          to.name === 'MyOrder' ||
          to.name === 'DeliveryCartInProgress' ||
          to.name === 'SubCategories'){
        this.displayIconCartRight = true;
      }else{
        this.displayIconCartRight = false;
      }
    }
  },
};
</script>

<style lang="scss">
.header-nav-bar .toolbar-title-header-logo {
    position: absolute;
    left: 0;
    top: 10%;
    padding-left: 0px!important;
    width: 100%;
    z-index: -1;
    img {
      height: 46px !important;
    }
}
.v-toolbar__title.toolbar-title-header-logo img {
    display: block;
    margin-left: auto;
    margin-right: auto;
}
.header-body {
  margin-right: 5px;
  vertical-align: text-bottom !important;
}
.v-toolbar__content {
  height: 56px !important;
}
.v-toolbar__content, .v-toolbar__extension {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
}
</style>
